"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stepUpMFA = stepUpMFA;
exports.startWebAuthnAuthenticationWatcher = startWebAuthnAuthenticationWatcher;
exports.startWebAuthnAuthenticationWorker = startWebAuthnAuthenticationWorker;
exports.authenticateViaWebAuthnWatcher = authenticateViaWebAuthnWatcher;
exports.authenticateViaWebAuthnWorker = authenticateViaWebAuthnWorker;
exports.fetchUserMFAStatusWatcher = fetchUserMFAStatusWatcher;
exports.fetchUserMFAStatusWorker = fetchUserMFAStatusWorker;
exports.default = void 0;

var _lodash = require("lodash");

var _effects = require("redux-saga/effects");

var _action = require("../../../../../../components/notification/action");

var _action2 = require("../../../../../../components/spinner-overlay/action");

var _secretManagerService = require("../../../../../../services/secret-manager-service");

var _commonConstants = require("../../../../../../utils/common-constants");

var _externalization = require("../../../../externalization");

var _action3 = require("./action");

var _constants = require("./constants");

var _service = require("./service");

var _userService = require("../../../../../../services/user-service");

var _constants2 = require("../../../../../../components/StepUpModal/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(secretListWatcher),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(secretListWorker),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(secretListLoadMoreWatcher),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(secretListLoadMoreWorker),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(stepUpMFA),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(stepUpMFAWorker),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(secretDetailsWatcher),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(secretDetailsWorker),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(secretTemplateDetailsWatcher),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(secretTemplateDetailsWorker),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(fetchUsersWatcher),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(fetchUsersWorker),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(fetchGroupsWatcher),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(fetchGroupsWorker),
    _marked15 = /*#__PURE__*/regeneratorRuntime.mark(secretFileDownloadWatcher),
    _marked16 = /*#__PURE__*/regeneratorRuntime.mark(secretFileDownloadWorker),
    _marked17 = /*#__PURE__*/regeneratorRuntime.mark(secretOTPWatcher),
    _marked18 = /*#__PURE__*/regeneratorRuntime.mark(secretOTPWorker),
    _marked19 = /*#__PURE__*/regeneratorRuntime.mark(startWebAuthnAuthenticationWatcher),
    _marked20 = /*#__PURE__*/regeneratorRuntime.mark(startWebAuthnAuthenticationWorker),
    _marked21 = /*#__PURE__*/regeneratorRuntime.mark(authenticateViaWebAuthnWatcher),
    _marked22 = /*#__PURE__*/regeneratorRuntime.mark(authenticateViaWebAuthnWorker),
    _marked23 = /*#__PURE__*/regeneratorRuntime.mark(fetchUserMFAStatusWatcher),
    _marked24 = /*#__PURE__*/regeneratorRuntime.mark(fetchUserMFAStatusWorker);

var getVaultDetails = function getVaultDetails(state) {
  return state.vaultLanding.data;
};

function secretListWatcher() {
  return regeneratorRuntime.wrap(function secretListWatcher$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.takeLatest)(_constants.secretListTypes.SECRET_LIST_REQUEST, secretListWorker);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function secretListWorker(_ref) {
  var payload, state, vaultId, searchTerm, totalSecretList, secretListPagination, listData, secretListData, _error$response$data$, _error$response, _error$response$data, reason;

  return regeneratorRuntime.wrap(function secretListWorker$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref.payload;
          _context2.next = 3;
          return (0, _effects.select)();

        case 3:
          state = _context2.sent;
          _context2.prev = 4;
          _context2.next = 7;
          return (0, _effects.put)((0, _action3.loadingSecretList)());

        case 7:
          vaultId = function vaultId(state) {
            return state.vaultLanding.data.id;
          };

          searchTerm = function searchTerm(state) {
            var _state$userSecretsRed, _state$userSecretsRed2, _state$userSecretsRed3;

            return state === null || state === void 0 ? void 0 : (_state$userSecretsRed = state.userSecretsReducer) === null || _state$userSecretsRed === void 0 ? void 0 : (_state$userSecretsRed2 = _state$userSecretsRed.allSecretsReducer) === null || _state$userSecretsRed2 === void 0 ? void 0 : (_state$userSecretsRed3 = _state$userSecretsRed2.secretList) === null || _state$userSecretsRed3 === void 0 ? void 0 : _state$userSecretsRed3.searchTerm;
          };

          payload.vaultId = vaultId(state);
          payload.search = searchTerm(state);
          totalSecretList = [];
          secretListPagination = {};
          _context2.next = 15;
          return (0, _effects.call)(_service.fetchSecretList, payload);

        case 15:
          listData = _context2.sent;
          totalSecretList = _toConsumableArray(listData === null || listData === void 0 ? void 0 : listData.result);
          secretListPagination = listData === null || listData === void 0 ? void 0 : listData.pagination;
          secretListData = totalSecretList;
          _context2.next = 21;
          return (0, _effects.put)((0, _action3.successSecretList)(secretListData, secretListPagination));

        case 21:
          _context2.next = 30;
          break;

        case 23:
          _context2.prev = 23;
          _context2.t0 = _context2["catch"](4);
          reason = (_error$response$data$ = _context2.t0 === null || _context2.t0 === void 0 ? void 0 : (_error$response = _context2.t0.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message) !== null && _error$response$data$ !== void 0 ? _error$response$data$ : '';
          _context2.next = 28;
          return (0, _effects.put)((0, _action3.failureSecretList)(reason));

        case 28:
          _context2.next = 30;
          return (0, _effects.put)((0, _action.openNotification)(_commonConstants.errorNotificationType, (0, _externalization.translate)('SECRETS_MODULE.ERROR_LOADING_SECRETS_LIST', {
            reason: reason
          }), true, _commonConstants.errorNotificationDuration));

        case 30:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[4, 23]]);
}

function secretListLoadMoreWatcher() {
  return regeneratorRuntime.wrap(function secretListLoadMoreWatcher$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeLatest)(_constants.secretListTypes.SECRET_LIST_LOAD_MORE_REQUEST, secretListLoadMoreWorker);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function secretListLoadMoreWorker(_ref2) {
  var payload, state, vaultId, searchTerm, nextPageToken, secretListData, _error$response2, _error$response2$data, reason;

  return regeneratorRuntime.wrap(function secretListLoadMoreWorker$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _ref2.payload;
          _context4.next = 3;
          return (0, _effects.select)();

        case 3:
          state = _context4.sent;
          _context4.prev = 4;
          _context4.next = 7;
          return (0, _effects.put)((0, _action3.loadingSecretListLoadMore)());

        case 7:
          vaultId = function vaultId(state) {
            return state.vaultLanding.data.id;
          };

          searchTerm = function searchTerm(state) {
            var _state$userSecretsRed4, _state$userSecretsRed5, _state$userSecretsRed6;

            return state === null || state === void 0 ? void 0 : (_state$userSecretsRed4 = state.userSecretsReducer) === null || _state$userSecretsRed4 === void 0 ? void 0 : (_state$userSecretsRed5 = _state$userSecretsRed4.allSecretsReducer) === null || _state$userSecretsRed5 === void 0 ? void 0 : (_state$userSecretsRed6 = _state$userSecretsRed5.secretList) === null || _state$userSecretsRed6 === void 0 ? void 0 : _state$userSecretsRed6.searchTerm;
          };

          nextPageToken = function nextPageToken(state) {
            var _state$userSecretsRed7, _state$userSecretsRed8, _state$userSecretsRed9, _state$userSecretsRed10;

            return state === null || state === void 0 ? void 0 : (_state$userSecretsRed7 = state.userSecretsReducer) === null || _state$userSecretsRed7 === void 0 ? void 0 : (_state$userSecretsRed8 = _state$userSecretsRed7.allSecretsReducer) === null || _state$userSecretsRed8 === void 0 ? void 0 : (_state$userSecretsRed9 = _state$userSecretsRed8.secretList) === null || _state$userSecretsRed9 === void 0 ? void 0 : (_state$userSecretsRed10 = _state$userSecretsRed9.pagination) === null || _state$userSecretsRed10 === void 0 ? void 0 : _state$userSecretsRed10.next;
          };

          payload.vaultId = vaultId(state);
          payload.search = searchTerm(state);
          payload.next = nextPageToken(state);
          _context4.next = 15;
          return (0, _effects.call)(_service.fetchSecretList, payload);

        case 15:
          secretListData = _context4.sent;
          _context4.next = 18;
          return (0, _effects.put)((0, _action3.successSecretListLoadMore)(secretListData));

        case 18:
          _context4.next = 27;
          break;

        case 20:
          _context4.prev = 20;
          _context4.t0 = _context4["catch"](4);
          reason = (_context4.t0 === null || _context4.t0 === void 0 ? void 0 : (_error$response2 = _context4.t0.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data.message) || '';
          _context4.next = 25;
          return (0, _effects.put)((0, _action3.failureSecretListLoadMore)(reason));

        case 25:
          _context4.next = 27;
          return (0, _effects.put)((0, _action.openNotification)(_commonConstants.errorNotificationType, (0, _externalization.translate)('SECRETS_MODULE.ERROR_LOADING_SECRETS_LIST', {
            reason: reason
          }), true, _commonConstants.errorNotificationDuration));

        case 27:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[4, 20]]);
}

function stepUpMFA() {
  return regeneratorRuntime.wrap(function stepUpMFA$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeLatest)(_constants.AuthenticateStepUpMFATypes.SECRET_STEP_UP_MFA_REQUEST, stepUpMFAWorker);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function stepUpMFAWorker(_ref3) {
  var payload, factor, postBody, stepUpMFAData, response;
  return regeneratorRuntime.wrap(function stepUpMFAWorker$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _ref3.payload;
          factor = payload.factor, postBody = payload.postBody;
          _context6.next = 4;
          return (0, _effects.put)((0, _action2.initSpinnerOverlay)({
            open: true,
            size: 'medium'
          }));

        case 4:
          _context6.prev = 4;
          _context6.next = 7;
          return (0, _effects.call)(_userService.authenticateStepUpMFA, factor, postBody);

        case 7:
          stepUpMFAData = _context6.sent;
          _context6.next = 10;
          return (0, _effects.put)((0, _action3.successStepUpMFA)(stepUpMFAData));

        case 10:
          _context6.next = 17;
          break;

        case 12:
          _context6.prev = 12;
          _context6.t0 = _context6["catch"](4);
          response = _context6.t0.response;
          _context6.next = 17;
          return (0, _effects.put)((0, _action3.failureStepUpMFA)({
            data: response === null || response === void 0 ? void 0 : response.data,
            status: response === null || response === void 0 ? void 0 : response.status
          }));

        case 17:
          _context6.next = 19;
          return (0, _effects.put)((0, _action2.initSpinnerOverlay)({
            open: false,
            size: 'medium'
          }));

        case 19:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[4, 12]]);
}

function secretDetailsWatcher() {
  return regeneratorRuntime.wrap(function secretDetailsWatcher$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeLatest)(_constants.SecretDetailsTypes.SECRET_DETAILS_REQUEST, secretDetailsWorker);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}

function secretDetailsWorker(_ref4) {
  var payload, path, data, _yield$select, vaultId, startTime, secretData, response;

  return regeneratorRuntime.wrap(function secretDetailsWorker$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          payload = _ref4.payload;
          path = payload.path, data = payload.data;
          _context8.prev = 2;
          _context8.next = 5;
          return (0, _effects.put)((0, _action3.loadingSecretDetails)());

        case 5:
          _context8.next = 7;
          return (0, _effects.select)(getVaultDetails);

        case 7:
          _yield$select = _context8.sent;
          vaultId = _yield$select.id;

          if (!(0, _lodash.isEmpty)(data)) {
            _context8.next = 14;
            break;
          }

          _context8.next = 12;
          return (0, _effects.put)((0, _action3.resetUserDetails)());

        case 12:
          _context8.next = 14;
          return (0, _effects.put)((0, _action3.resetGroupsDetails)());

        case 14:
          startTime = Date.now();
          _context8.next = 17;
          return (0, _effects.call)(_service.fetchSecretDetails, path, data, vaultId);

        case 17:
          secretData = _context8.sent;
          _context8.next = 20;
          return (0, _effects.put)((0, _action3.successSecretDetails)(_objectSpread(_objectSpread({}, secretData), {}, {
            loadingTime: Math.ceil((Date.now() - startTime) / 1000)
          })));

        case 20:
          _context8.next = 22;
          return (0, _effects.put)((0, _action2.initSpinnerOverlay)({
            open: false,
            size: 'medium'
          }));

        case 22:
          _context8.next = 24;
          return (0, _effects.put)((0, _action3.requestSecretTemplateDetails)(secretData === null || secretData === void 0 ? void 0 : secretData.staticSecretTemplateId));

        case 24:
          _context8.next = 33;
          break;

        case 26:
          _context8.prev = 26;
          _context8.t0 = _context8["catch"](2);
          response = _context8.t0.response;
          _context8.next = 31;
          return (0, _effects.put)((0, _action3.failureSecretDetails)({
            data: response === null || response === void 0 ? void 0 : response.data,
            status: response === null || response === void 0 ? void 0 : response.status
          }));

        case 31:
          _context8.next = 33;
          return (0, _effects.put)((0, _action2.initSpinnerOverlay)({
            open: false,
            size: 'medium'
          }));

        case 33:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8, null, [[2, 26]]);
}

function secretTemplateDetailsWatcher() {
  return regeneratorRuntime.wrap(function secretTemplateDetailsWatcher$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.takeLatest)(_constants.secretTemplateDetailsTypes.SECRET_TEMPLATE_DETAILS_REQUEST, secretTemplateDetailsWorker);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}

function secretTemplateDetailsWorker(_ref5) {
  var payload, startTime, secretTemplateData, _error$response3, _error$response3$data, reason;

  return regeneratorRuntime.wrap(function secretTemplateDetailsWorker$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          payload = _ref5.payload;
          _context10.prev = 1;
          _context10.next = 4;
          return (0, _effects.put)((0, _action3.loadingSecretTemplateDetails)());

        case 4:
          startTime = Date.now();
          _context10.next = 7;
          return (0, _effects.call)(_service.fetchSecretTemplateDetails, payload);

        case 7:
          secretTemplateData = _context10.sent;
          _context10.next = 10;
          return (0, _effects.put)((0, _action3.successSecretTemplateDetails)(_objectSpread(_objectSpread({}, secretTemplateData), {}, {
            loadingTime: Math.ceil((Date.now() - startTime) / 1000)
          })));

        case 10:
          _context10.next = 19;
          break;

        case 12:
          _context10.prev = 12;
          _context10.t0 = _context10["catch"](1);
          reason = (_context10.t0 === null || _context10.t0 === void 0 ? void 0 : (_error$response3 = _context10.t0.response) === null || _error$response3 === void 0 ? void 0 : (_error$response3$data = _error$response3.data) === null || _error$response3$data === void 0 ? void 0 : _error$response3$data.message) || '';
          _context10.next = 17;
          return (0, _effects.put)((0, _action3.failureSecretTemplateDetails)(_context10.t0));

        case 17:
          _context10.next = 19;
          return (0, _effects.put)((0, _action.openNotification)(_commonConstants.errorNotificationType, (0, _externalization.translate)('SECRETS_MODULE.ERROR_LOADING_SECRET', {
            reason: reason
          }), true, _commonConstants.errorNotificationDuration));

        case 19:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10, null, [[1, 12]]);
}

function fetchUsersWatcher() {
  return regeneratorRuntime.wrap(function fetchUsersWatcher$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.takeLatest)(_constants.fetchUsersType.FETCH_USERS_REQUEST_VIEW_SECRET, fetchUsersWorker);

        case 2:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11);
}

function fetchUsersWorker(_ref6) {
  var userIdList, usersData, filterUserData, _response$data, response, reason;

  return regeneratorRuntime.wrap(function fetchUsersWorker$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          userIdList = _ref6.payload;
          _context12.prev = 1;
          _context12.next = 4;
          return (0, _effects.put)((0, _action3.loadingUserDetails)());

        case 4:
          _context12.next = 6;
          return (0, _effects.call)(_service.fetchUsers);

        case 6:
          usersData = _context12.sent;
          filterUserData = (0, _lodash.intersectionWith)(usersData, userIdList, function (user, id) {
            return user.userId === id;
          });
          _context12.next = 10;
          return (0, _effects.put)((0, _action3.successUserDetails)(filterUserData));

        case 10:
          _context12.next = 20;
          break;

        case 12:
          _context12.prev = 12;
          _context12.t0 = _context12["catch"](1);
          response = _context12.t0.response;
          reason = (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.message) || '';
          _context12.next = 18;
          return (0, _effects.put)((0, _action.openNotification)(_commonConstants.errorNotificationType, reason, true, _commonConstants.errorNotificationDuration));

        case 18:
          _context12.next = 20;
          return (0, _effects.put)((0, _action3.failureUserDetails)(reason));

        case 20:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked12, null, [[1, 12]]);
}

function fetchGroupsWatcher() {
  return regeneratorRuntime.wrap(function fetchGroupsWatcher$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.takeLatest)(_constants.fetchGroupsType.FETCH_GROUPS_REQUEST_VIEW_SECRET, fetchGroupsWorker);

        case 2:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked13);
}

function fetchGroupsWorker(_ref8) {
  var groupIdList, groupsData, filterGroupData, _response$data2, response, reason;

  return regeneratorRuntime.wrap(function fetchGroupsWorker$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          groupIdList = _ref8.payload;
          _context14.prev = 1;
          _context14.next = 4;
          return (0, _effects.put)((0, _action3.loadingGroupsDetails)());

        case 4:
          _context14.next = 6;
          return (0, _effects.call)(_service.fetchGroups);

        case 6:
          groupsData = _context14.sent;
          filterGroupData = (0, _lodash.intersectionWith)(groupsData, groupIdList, function (group, id) {
            return group.userTagId === id;
          });
          _context14.next = 10;
          return (0, _effects.put)((0, _action3.successGroupsDetails)(filterGroupData));

        case 10:
          _context14.next = 20;
          break;

        case 12:
          _context14.prev = 12;
          _context14.t0 = _context14["catch"](1);
          response = _context14.t0.response;
          reason = (response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.message) || '';
          _context14.next = 18;
          return (0, _effects.put)((0, _action.openNotification)(_commonConstants.errorNotificationType, reason, true, _commonConstants.errorNotificationDuration));

        case 18:
          _context14.next = 20;
          return (0, _effects.put)((0, _action3.failureGroupsDetails)(reason));

        case 20:
        case "end":
          return _context14.stop();
      }
    }
  }, _marked14, null, [[1, 12]]);
}

function secretFileDownloadWatcher() {
  return regeneratorRuntime.wrap(function secretFileDownloadWatcher$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.takeLatest)(_constants.mySecretFileDownloadTypes.MY_SECRET_FILE_DOWNLOAD_REQUEST, secretFileDownloadWorker);

        case 2:
        case "end":
          return _context15.stop();
      }
    }
  }, _marked15);
}

function secretFileDownloadWorker(_ref10) {
  var payload, parents, vaultId, updatedParents, fileData, response, contentType, _payload, responseData;

  return regeneratorRuntime.wrap(function secretFileDownloadWorker$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          payload = _ref10.payload;
          parents = payload.parents, vaultId = payload.vaultId;
          updatedParents = parents.slice(1);
          _context16.prev = 3;
          _context16.next = 6;
          return (0, _effects.put)({
            type: _constants.mySecretFileDownloadTypes.MY_SECRET_FILE_DOWNLOAD_LOADING
          });

        case 6:
          _context16.next = 8;
          return (0, _effects.call)(_secretManagerService.downloadSecretFile, {
            parents: updatedParents,
            vaultId: vaultId
          });

        case 8:
          fileData = _context16.sent;
          _context16.next = 11;
          return (0, _effects.put)({
            type: _constants.mySecretFileDownloadTypes.MY_SECRET_FILE_DOWNLOAD_SUCCESS,
            payload: fileData
          });

        case 11:
          _context16.next = 25;
          break;

        case 13:
          _context16.prev = 13;
          _context16.t0 = _context16["catch"](3);
          response = _context16.t0.response;
          contentType = response.headers['content-type'];
          _payload = response.data;

          if (!(contentType && contentType.includes('application/json'))) {
            _context16.next = 23;
            break;
          }

          _context16.next = 21;
          return (0, _effects.call)([response.data, 'text']);

        case 21:
          responseData = _context16.sent;
          // Calls the `text` method on the Blob
          _payload = JSON.parse(responseData);

        case 23:
          _context16.next = 25;
          return (0, _effects.put)({
            type: _constants.mySecretFileDownloadTypes.MY_SECRET_FILE_DOWNLOAD_FAILURE,
            payload: _payload,
            statusCode: response.status
          });

        case 25:
        case "end":
          return _context16.stop();
      }
    }
  }, _marked16, null, [[3, 13]]);
}

function secretOTPWatcher() {
  return regeneratorRuntime.wrap(function secretOTPWatcher$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.takeLatest)(_constants.secretOTPTypes.SECRET_OTP_FETCH_REQUEST, secretOTPWorker);

        case 2:
        case "end":
          return _context17.stop();
      }
    }
  }, _marked17);
}

function secretOTPWorker(_ref12) {
  var payload, parents, _yield$select2, vaultId, startTime, data, value, _response$response, errorResponse;

  return regeneratorRuntime.wrap(function secretOTPWorker$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          payload = _ref12.payload;
          parents = payload.parents;
          _context18.next = 4;
          return (0, _effects.select)(getVaultDetails);

        case 4:
          _yield$select2 = _context18.sent;
          vaultId = _yield$select2.id;
          _context18.prev = 6;
          _context18.next = 9;
          return (0, _effects.put)({
            type: _constants.secretOTPTypes.SECRET_OTP_FETCH_LOADING
          });

        case 9:
          startTime = Date.now();
          _context18.next = 12;
          return (0, _effects.call)(_service.fetchSecretDetails, parents, {}, vaultId);

        case 12:
          data = _context18.sent;
          value = data.value;
          _context18.next = 16;
          return (0, _effects.put)({
            type: _constants.secretOTPTypes.SECRET_OTP_FETCH_SUCCESS,
            payload: {
              otp: (value === null || value === void 0 ? void 0 : value.OTP) || '',
              loadingTime: Math.ceil((Date.now() - startTime) / 1000)
            }
          });

        case 16:
          _context18.next = 23;
          break;

        case 18:
          _context18.prev = 18;
          _context18.t0 = _context18["catch"](6);
          errorResponse = _context18.t0 === null || _context18.t0 === void 0 ? void 0 : (_response$response = _context18.t0.response) === null || _response$response === void 0 ? void 0 : _response$response.data;
          _context18.next = 23;
          return (0, _effects.put)({
            type: _constants.secretOTPTypes.SECRET_OTP_FETCH_FAILURE,
            payload: errorResponse
          });

        case 23:
        case "end":
          return _context18.stop();
      }
    }
  }, _marked18, null, [[6, 18]]);
}

function startWebAuthnAuthenticationWatcher() {
  return regeneratorRuntime.wrap(function startWebAuthnAuthenticationWatcher$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return (0, _effects.takeLatest)(_commonConstants.stepUpAuthenticationTypes.START_WEB_AUTHN_AUTHENTICATION_REQUEST, startWebAuthnAuthenticationWorker);

        case 2:
        case "end":
          return _context19.stop();
      }
    }
  }, _marked19);
}

function startWebAuthnAuthenticationWorker() {
  var webAuthnInitialResponse;
  return regeneratorRuntime.wrap(function startWebAuthnAuthenticationWorker$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 2;
          return (0, _effects.put)((0, _action2.initSpinnerOverlay)({
            open: true,
            size: 'medium'
          }));

        case 2:
          _context20.prev = 2;
          _context20.next = 5;
          return (0, _effects.call)(_userService.initiateWebAuthnAuthentication);

        case 5:
          webAuthnInitialResponse = _context20.sent;

          if (!(0, _lodash.isEmpty)(webAuthnInitialResponse)) {
            _context20.next = 8;
            break;
          }

          throw new Error('Cannot complete webauthn authentication.');

        case 8:
          _context20.next = 10;
          return (0, _effects.put)((0, _action3.successStartWebAuthnAuthentication)(webAuthnInitialResponse));

        case 10:
          _context20.next = 17;
          break;

        case 12:
          _context20.prev = 12;
          _context20.t0 = _context20["catch"](2);

          if (!((_context20.t0 === null || _context20.t0 === void 0 ? void 0 : _context20.t0.name) !== 'AbortError')) {
            _context20.next = 17;
            break;
          }

          _context20.next = 17;
          return (0, _effects.put)((0, _action3.failureStartWebAuthnAuthentication)(_context20.t0));

        case 17:
          _context20.next = 19;
          return (0, _effects.put)((0, _action2.initSpinnerOverlay)({
            open: false,
            size: 'medium'
          }));

        case 19:
        case "end":
          return _context20.stop();
      }
    }
  }, _marked20, null, [[2, 12]]);
}

function authenticateViaWebAuthnWatcher() {
  return regeneratorRuntime.wrap(function authenticateViaWebAuthnWatcher$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          _context21.next = 2;
          return (0, _effects.takeLatest)(_commonConstants.stepUpAuthenticationTypes.AUTHENTICATE_VIA_WEB_AUTHN_REQUEST, authenticateViaWebAuthnWorker);

        case 2:
        case "end":
          return _context21.stop();
      }
    }
  }, _marked21);
}

function authenticateViaWebAuthnWorker(_ref13) {
  var payload, webAuthnInitialData, publicKeyCredential, stepUpMFAData;
  return regeneratorRuntime.wrap(function authenticateViaWebAuthnWorker$(_context22) {
    while (1) {
      switch (_context22.prev = _context22.next) {
        case 0:
          payload = _ref13.payload;
          webAuthnInitialData = payload.webAuthnInitialData, publicKeyCredential = payload.publicKeyCredential;
          _context22.prev = 2;

          if (publicKeyCredential) {
            _context22.next = 5;
            break;
          }

          throw new Error('Cannot complete webauthn authentication.');

        case 5:
          _context22.next = 7;
          return (0, _effects.put)((0, _action2.initSpinnerOverlay)({
            open: true,
            size: 'medium'
          }));

        case 7:
          _context22.next = 9;
          return (0, _effects.call)(_userService.authenticateStepUpMFA, _constants2.mfaFactor.webAuthN, {
            action: 'FINISH_AUTHN',
            requestOptionsId: webAuthnInitialData.additionalDetails.requestOptionsId,
            publicKeyCredentialJson: JSON.stringify(publicKeyCredential)
          });

        case 9:
          stepUpMFAData = _context22.sent;
          _context22.next = 12;
          return (0, _effects.put)((0, _action3.successStepUpMFA)(stepUpMFAData));

        case 12:
          _context22.next = 19;
          break;

        case 14:
          _context22.prev = 14;
          _context22.t0 = _context22["catch"](2);

          if (!((_context22.t0 === null || _context22.t0 === void 0 ? void 0 : _context22.t0.name) !== 'AbortError')) {
            _context22.next = 19;
            break;
          }

          _context22.next = 19;
          return (0, _effects.put)((0, _action3.failureStepUpMFA)(_context22.t0));

        case 19:
          _context22.next = 21;
          return (0, _effects.put)((0, _action2.initSpinnerOverlay)({
            open: false,
            size: 'medium'
          }));

        case 21:
        case "end":
          return _context22.stop();
      }
    }
  }, _marked22, null, [[2, 14]]);
}

function fetchUserMFAStatusWatcher() {
  return regeneratorRuntime.wrap(function fetchUserMFAStatusWatcher$(_context23) {
    while (1) {
      switch (_context23.prev = _context23.next) {
        case 0:
          _context23.next = 2;
          return (0, _effects.takeLatest)(_commonConstants.stepUpAuthenticationTypes.FETCH_USER_MFA_STATUS_REQUEST, fetchUserMFAStatusWorker);

        case 2:
        case "end":
          return _context23.stop();
      }
    }
  }, _marked23);
}

function fetchUserMFAStatusWorker() {
  var userMFAStatus;
  return regeneratorRuntime.wrap(function fetchUserMFAStatusWorker$(_context24) {
    while (1) {
      switch (_context24.prev = _context24.next) {
        case 0:
          _context24.next = 2;
          return (0, _effects.put)((0, _action2.initSpinnerOverlay)({
            open: true,
            size: 'medium'
          }));

        case 2:
          _context24.prev = 2;
          _context24.next = 5;
          return (0, _effects.call)(_userService.getUserMFAStatus, true);

        case 5:
          userMFAStatus = _context24.sent;
          _context24.next = 8;
          return (0, _effects.put)((0, _action3.successFetchUserMFAStatus)(userMFAStatus));

        case 8:
          _context24.next = 14;
          break;

        case 10:
          _context24.prev = 10;
          _context24.t0 = _context24["catch"](2);
          _context24.next = 14;
          return (0, _effects.put)((0, _action3.failureFetchUserMFAStatus)(_context24.t0));

        case 14:
          _context24.next = 16;
          return (0, _effects.put)((0, _action2.initSpinnerOverlay)({
            open: false,
            size: 'medium'
          }));

        case 16:
        case "end":
          return _context24.stop();
      }
    }
  }, _marked24, null, [[2, 10]]);
}

var _default = (0, _effects.all)([(0, _effects.fork)(secretListWatcher), (0, _effects.fork)(secretDetailsWatcher), (0, _effects.fork)(stepUpMFA), (0, _effects.fork)(secretTemplateDetailsWatcher), (0, _effects.fork)(secretListLoadMoreWatcher), (0, _effects.fork)(fetchUsersWatcher), (0, _effects.fork)(fetchGroupsWatcher), (0, _effects.fork)(secretFileDownloadWatcher), (0, _effects.fork)(secretOTPWatcher), (0, _effects.fork)(startWebAuthnAuthenticationWatcher), (0, _effects.fork)(fetchUserMFAStatusWatcher), (0, _effects.fork)(authenticateViaWebAuthnWatcher)]);

exports.default = _default;